module.exports = __webpack_public_path__ + "img/5b64fb4.png";